/**
 * Closes the cart drawer before opening the cart signup modal so the popup
 * is not hidden behind the drawer overlay.
 */
document.addEventListener('click', (evt) => {
  const button = evt.target.closest('modal-opener[data-modal="cart-signup-modal"] button');
  if (!button) return;

  const cartDrawer = document.getElementById('cart-drawer');
  if (cartDrawer?.hasAttribute('open')) {
    cartDrawer.close();
  }
}, true);

const CART_SIGNUP_DELAY_DEFAULT_MS = 5000;

function getCartSignupDelayMs(formContainer) {
  const seconds = Number.parseInt(formContainer?.dataset.delaySeconds, 10);

  if (Number.isNaN(seconds)) {
    return CART_SIGNUP_DELAY_DEFAULT_MS;
  }

  const clampedSeconds = Math.min(8, Math.max(1, seconds));
  return clampedSeconds * 1000;
}

/**
 * After cart signup form submission, show a loader then a Checkout button.
 */
function initCartSignupForm() {
  const modal = document.getElementById('cart-signup-modal');
  const formContainer = modal?.querySelector('.cart-signup-modal__form');
  const formId = formContainer?.dataset.formId;
  const cartUrl = formContainer?.dataset.cartUrl || '/cart';

  if (!modal || !formId || !formContainer) return;

  const formFields = formContainer.querySelector('.cart-signup-modal__form-fields');
  const postSubmit = formContainer.querySelector('.cart-signup-modal__post-submit');
  const creatingState = formContainer.querySelector('.cart-signup-modal__creating');
  const checkoutReady = formContainer.querySelector('.cart-signup-modal__checkout-ready');
  const checkoutButton = formContainer.querySelector('.js-cart-signup-checkout');
  const heading = modal.querySelector('.cart-signup-modal__heading');
  const description = modal.querySelector('.cart-signup-modal__description');
  const formCompleteHeading = formContainer.dataset.formCompleteHeading;

  const proceedToCheckout = () => {
    if (typeof modal.close === 'function') {
      modal.close();
    }

    const cartForm = document.getElementById('cart') || document.getElementById('cart-drawer-form');
    const checkoutControl = cartForm?.querySelector('[name="checkout"]:not([disabled])');

    if (checkoutControl) {
      checkoutControl.click();
      return;
    }

    const cartPath = new URL(cartUrl, window.location.origin).pathname;

    if (window.location.pathname === cartPath) {
      window.location.reload();
      return;
    }

    window.location.href = cartUrl;
  };

  const showPostSubmitFlow = () => {
    if (!formFields || !postSubmit || !creatingState || !checkoutReady || !checkoutButton) return;

    // Pre-form intro copy is no longer relevant after submission
    if (description) description.hidden = true;
    if (heading && formCompleteHeading) {
      heading.textContent = formCompleteHeading;
    }

    formFields.hidden = true;
    postSubmit.hidden = false;
    creatingState.hidden = false;
    checkoutReady.hidden = true;

    window.setTimeout(() => {
      creatingState.hidden = true;
      checkoutReady.hidden = false;
    }, getCartSignupDelayMs(formContainer));

    checkoutButton.addEventListener('click', proceedToCheckout, { once: true });
  };

  const attachFormListener = () => {
    const form = modal.querySelector(`form[data-cf-form="${formId}"]`);
    if (!form || form.dataset.cartSignupBound === 'true') return !!form;

    form.dataset.cartSignupBound = 'true';
    form.addEventListener('cf:form_submitted', showPostSubmitFlow);

    return true;
  };

  if (!attachFormListener()) {
    document.addEventListener('cf:ready', attachFormListener, { once: true });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCartSignupForm);
} else {
  initCartSignupForm();
}
